// extracted by mini-css-extract-plugin
export default {"appSearchBar":"AppSearchBar_appSearchBar__sz-gV","searchBtn":"AppSearchBar_searchBtn__faLLs"};